import React from 'react';
import './Reasons.css';
import image1 from '../../assets/image1.png';
import image2 from '../../assets/image2.png';
import image3 from '../../assets/image3.png';
import image4 from '../../assets/image4.png';
import nb from '../../assets/nb.png';
import adidas from '../../assets/adidas.png';
import nike from '../../assets/nike.png';
// IMPORTANT NOTE:
// The image shows an orange checkmark icon for the list items.
// Your current import `tick from '../../assets/nike.png'` will display the Nike logo as a tick.
// If you want the checkmark as seen in the image, you'll need to replace 'nike.png'
// with an actual checkmark icon asset (e.g., 'tick.png' or an SVG icon).
import tick from '../../assets/tick.png'; 

const Reasons = () => {
  return (
    <div className="reasons" id="reasons">
      <div className="left-r">
        <img src={image1} alt="Man lifting weights" />
        <img src={image2} alt="Man doing bicep curls" />
        <img src={image3} alt="Dumbbells in a gym" />
        <img src={image4} alt="Man using a gym machine" />
      </div>
      <div className="right-r">
        <span className="orange-text">Some Reasons</span>
        <h2>
          <span className="stroke-text">Why</span> <span>Choose us?</span>
        </h2>

        <div className="details-list">
          <div><img src={tick} alt="Checkmark icon" /><span>Over 140+ expert coaches</span></div>
          <div><img src={tick} alt="Checkmark icon" /><span>Train smarter and faster than before</span></div>
          <div><img src={tick} alt="Checkmark icon" /><span>1 free program for new member</span></div>
          <div><img src={tick} alt="Checkmark icon" /><span>Reliable partners</span></div>
        </div>

        <span className="partners-text">Our Partners</span>
        <div className="partner-logos">
          <img src={nb} alt="New Balance logo" />
          <img src={adidas} alt="Adidas logo" />
          <img src={nike} alt="Nike logo" />
        </div>
      </div>
    </div>
  );
};

export default Reasons;